import { Directive, ViewContainerRef } from '@angular/core';


@Directive({
    selector: '[ebInnerComponentHost]',
    standalone: false
})
export class EbInnerComponentHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
